/* eslint-disable camelcase */
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var homeVisitFeeReferenceColumns = [{
  name: 'Платени при отпускане',
  render: function render(_ref) {
    var initial_fees = _ref.initial_fees,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "initial_fees"
    }, initial_fees, " ", currency);
  }
}, {
  name: 'Опростени такси',
  render: function render(_ref2) {
    var dropped_fees = _ref2.dropped_fees,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "dropped_fees"
    }, dropped_fees, " ", currency);
  }
}, {
  name: 'Допълнително начислени платени',
  render: function render(_ref3) {
    var additional_payed_fees = _ref3.additional_payed_fees,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "additional_payed_fees"
    }, additional_payed_fees, " ", currency);
  }
}, {
  name: 'Допълнително начислени неплатени',
  render: function render(_ref4) {
    var additional_unpaid_fees = _ref4.additional_unpaid_fees,
        currency = _ref4.currency;
    return ___EmotionJSX("span", {
      "data-value": "additional_unpaid_fees"
    }, additional_unpaid_fees, " ", currency);
  }
}, {
  name: 'Общо платени',
  render: function render(_ref5) {
    var total_payed_fees = _ref5.total_payed_fees,
        currency = _ref5.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_payed_fees"
    }, total_payed_fees, " ", currency);
  }
}, {
  name: 'Месец',
  value: 'month_name'
}];